// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__snf3m","name":"styles_name__26Oqi","phone":"styles_phone__2jLF8"};